'use strict';

// If changing, align with SCENARIO in constants.py
module.exports = {
  alternative: 'alternative',
  candidate: 'candidate',
};
